import FormInputNumber from "@/components/forms/inputs/FormInputNumber";
import FormInputDateTime from "@/components/forms/inputs/FormInputDateTime";
import FormInputSelect from "@/components/forms/inputs/FormInputSelect";
import FormInputBoolean from "@/components/forms/inputs/FormInputBoolean";
import FormInputURL from "@/components/forms/inputs/FormInputURL";
import FormInputComponent from "@/components/forms/inputs/FormInputComponent";

export default {
    FormInputNumber,
    FormInputDateTime,
    FormInputSelect,
    FormInputBoolean,
    FormInputURL,
    FormInputComponent,
};
